module.exports = __webpack_public_path__ + "static/media/umbrellaStroller.a50e4aaf.svg";